import Logo from 'assets/images/logo-azapfy.png';
import Icone from 'assets/images/icone-azapfy.png';
import IconeBranco from 'assets/images/icone-azapfy-branco.png';
import LogoWeb from 'assets/images/logo-azapfy-web.png';
import LogoWebBranca from 'assets/images/logo-azapfy-web-branco.png';
import LogoCinza from 'assets/images/logo-cinza.png';
const logo = Logo;
const icone = Icone;
const logoWeb = LogoWeb;
const logoWebBranca = LogoWebBranca;
const iconeBranco = IconeBranco;
const logoCinza = LogoCinza;
export {
    logo,
    icone,
    logoWeb,
    logoWebBranca,
    iconeBranco,
    logoCinza
};
